export default "__VITE_ASSET__003673f4__"